// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"594":"7b063020","716":"0fa8c0d2","817":"fca2b13c"}[chunkId] + ".chunk.css";
};